/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type userTracking_viewer = {|
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactionsMostRecent?: ?{|
    +totalResults: ?number;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_viewer",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.initiated",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.submitted",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.confirmed",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
